/**
 * @file AdUnitSearchBottomSlot.tsx
 *
 * @fileoverview Renders row ad unit for the bottom of the job search page.
 */

interface AdUnitSearchBottomSlotProps {}

export default function AdUnitSearchBottomSlot({}: AdUnitSearchBottomSlotProps) {
  return <></>;
}

export { AdUnitSearchBottomSlot };
